import React from 'react';
import { Link } from 'react-router';
import logoBanorte from '../../img/logo-banorte.png';

export class Navbar extends React.Component {
	render() {
		return (
			<nav className="navbar navbar-light bg-semi-white">
				<div className="main-navbar-brand">
					<a role="button" className="navbar-brand color-secondary" onClick={this.props.toggleSidemenu} hidden={this.props.session.user === null}>
						<i className="fa fa-bars"></i>
					</a>
					<Link href="/" className="navbar-brand color-secondary">
						Banorte Acción PyME
					</Link>
				</div>
				<div className="text-center">
					<img className="img-block" src={logoBanorte} alt=""/>
				</div>
			</nav>
		);
	}
}


/** WEBPACK FOOTER **
 ** ./src/components/presentation/Navbar.jsx
 **/